import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';

export enum SelectSmallIconVariant {
  OFF = 'off',
  ON = 'on',
}

export interface ISelectSmallIConProps extends IConDefaultType {
  variant?: SelectSmallIconVariant;
}

function SelectSmallIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = SelectSmallIconVariant.OFF,
}: ISelectSmallIConProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SelectSmallIconVariant.OFF && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke={color || '#ADB0B8'} strokeWidth="2" />
          <path
            d="M8 12.36L10.2857 14.6L16 9"
            stroke={color || '#ADB0B8'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {variant === SelectSmallIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="selectS">
            <g id="check">
              <circle id="Ellipse 45" cx="12" cy="12" r="10" fill={theme.color.static.primary} />
              <path
                id="Vector"
                d="M8 12.36L10.2857 14.6L16 9"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </svg>
      )}
    </i>
  );
}

export default SelectSmallIcon;
